export function accessMap() {
  const mapContainer = document.querySelector('.map-access');
  if (!mapContainer) return;
  
  // Debug: Check if already initialized
  if (mapContainer.dataset.mapInitialized === 'true') {
    console.warn('Map already initialized, skipping...');
    return;
  }
  mapContainer.dataset.mapInitialized = 'true';

  // Get center position from data attributes or use default
  const centerLat = parseFloat(mapContainer.dataset.centerLat) || 35.0116;
  const centerLng = parseFloat(mapContainer.dataset.centerLng) || 135.7681;

  // Configuration object for easy adjustment
  const config = {
    // Padding in pixels for map bounds (adjustable)
    boundsPadding: {
      top: 50,
      right: 50,
      bottom: 50,
      left: 50
    },
    // Map styles (optional)
    styles: [],
    // Default map options
    mapOptions: {
      zoom: 14,
      center: { lat: centerLat, lng: centerLng }, // Use ACF position or Kyoto default
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    },
    // Marker options
    markerOptions: {
      // Custom marker icon can be added here
      // icon: '/path/to/custom-marker.png'
    },
    // InfoWindow close button customization
    infoWindowCloseButton: {
      enabled: false, // Set to true to enable customization
      width: '20px',
      height: '20px',
      top: '5px',
      right: '5px',
      opacity: '0.5',
      iconWidth: '10px',
      iconHeight: '10px'
    }
  };

  // Initialize map when Google Maps API is loaded
  function initMap() {
    // Prevent multiple initialization
    if (mapContainer.mapInitialized) {
      return;
    }
    mapContainer.mapInitialized = true;
    
    // Create map instance
    const map = new google.maps.Map(mapContainer, {
      ...config.mapOptions,
      styles: config.styles
    });

    // Collect all location data from archive elements
    const locationElements = document.querySelectorAll('.archive-element-access[data-lat][data-lng]');
    
    if (locationElements.length === 0) {
      console.warn('No location elements found with lat/lng data');
      return;
    }

    // Create bounds object to auto-fit all markers
    const bounds = new google.maps.LatLngBounds();
    const markers = [];
    let currentInfoWindow = null; // Track currently open InfoWindow

    // Process each location element
    locationElements.forEach((element, index) => {
      const lat = parseFloat(element.dataset.lat);
      const lng = parseFloat(element.dataset.lng);
      
      // Skip if invalid coordinates
      if (isNaN(lat) || isNaN(lng)) {
        console.warn(`Invalid coordinates for element ${index}:`, element);
        return;
      }

      const position = { lat, lng };
      
      // Get title and number from the element
      const title = element.dataset.title ? element.dataset.title : '';
      const number = element.dataset.number ? element.dataset.number : index + 1;
      
      // Create marker with default icon and white label
      const marker = new google.maps.Marker({
        position,
        map,
        ...config.markerOptions,
        title: title,
        label: {
          text: number.toString(),
          color: 'white',
          fontSize: '12px',
          fontWeight: 'bold'
        }
      });

      // Get address if available (you might need to add this field to your ACF)
      const address = element.dataset.address || '';

      // Add info window with location details
      const infoContent = `
        <div style="padding:0px 10px 10px 10px;max-width:250px;font-family:serif;">
          <h4 style="margin:0 0 0 0;font-size:14px;font-weight:bold;">
            ${element.href ? `<a href="${element.href}" style="color:inherit;text-decoration:underline;outline:none;" tabindex="-1">${number}. ${title}</a>` : `${number}. ${title}`}
          </h4>
          ${address ? `<p style="margin:7px 0 0 0;font-size:12px;">${address}</p>` : ''}
        </div>
      `;

      const infoWindow = new google.maps.InfoWindow({
        content: infoContent
      });

      // Add custom styling to InfoWindow close button if enabled
      if (config.infoWindowCloseButton.enabled) {
        google.maps.event.addListener(infoWindow, 'domready', () => {
          // Get the InfoWindow close button
          const iwCloseBtn = document.querySelector('.gm-ui-hover-effect');
          if (iwCloseBtn) {
            // Apply custom styles
            iwCloseBtn.style.width = config.infoWindowCloseButton.width;
            iwCloseBtn.style.height = config.infoWindowCloseButton.height;
            iwCloseBtn.style.top = config.infoWindowCloseButton.top;
            iwCloseBtn.style.right = config.infoWindowCloseButton.right;
            iwCloseBtn.style.opacity = config.infoWindowCloseButton.opacity;
            iwCloseBtn.style.outline = 'none';
            iwCloseBtn.setAttribute('tabindex', '-1');
            
            // Customize the close icon size
            const closeImg = iwCloseBtn.querySelector('img');
            if (closeImg) {
              closeImg.style.width = config.infoWindowCloseButton.iconWidth;
              closeImg.style.height = config.infoWindowCloseButton.iconHeight;
            }
          }
        });
      } else {
        // Even if customization is disabled, prevent focus on close button
        google.maps.event.addListener(infoWindow, 'domready', () => {
          const iwCloseBtn = document.querySelector('.gm-ui-hover-effect');
          if (iwCloseBtn) {
            iwCloseBtn.style.outline = 'none';
            iwCloseBtn.setAttribute('tabindex', '-1');
          }
        });
      }

      // Show info window on click
      marker.addListener('click', () => {
        if (currentInfoWindow) {
          currentInfoWindow.close();
        }
        infoWindow.open(map, marker);
        currentInfoWindow = infoWindow;
      });

      // Store marker reference on element for hover interaction
      element.mapMarker = marker;
      element.mapInfoWindow = infoWindow;

      // Add hover event to element
      element.addEventListener('mouseenter', () => {
        if (currentInfoWindow) {
          currentInfoWindow.close();
        }
        infoWindow.open(map, marker);
        currentInfoWindow = infoWindow;
      });

      element.addEventListener('mouseleave', () => {
        infoWindow.close();
        if (currentInfoWindow === infoWindow) {
          currentInfoWindow = null;
        }
      });

      markers.push(marker);
      bounds.extend(position);
    });

    // Only fit bounds if no custom center position is specified
    const hasCustomCenter = mapContainer.dataset.centerLat || mapContainer.dataset.centerLng;
    
    if (markers.length > 0 && !hasCustomCenter) {
      // Fit map to show all markers with padding only when using default center
      map.fitBounds(bounds, config.boundsPadding);

      // Prevent too much zoom for single marker
      if (markers.length === 1) {
        google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
          if (map.getZoom() > 16) {
            map.setZoom(16);
          }
        });
      }
    }

    // Store map instance for external access if needed
    mapContainer.mapInstance = map;
    mapContainer.markers = markers;
    mapContainer.config = config;

    // Add custom method to update bounds padding
    mapContainer.updateBoundsPadding = (newPadding) => {
      Object.assign(config.boundsPadding, newPadding);
      if (!hasCustomCenter) {
        map.fitBounds(bounds, config.boundsPadding);
      }
    };
  }

  // Create callback for Google Maps API
  window.initAccessMap = initMap;
  
  // Check if Google Maps API is already loaded
  if (window.google && window.google.maps) {
    initMap();
  }
}